import { OrderStatus } from '@/model/order/OrderStatus';
import { ShipmentFinancialStatus, ShipmentStatus } from '@/model/shipment';

import { isSomeEnum } from './ObjectUtil';

export const ORDER_STATUS = [
  OrderStatus.PENDING,
  OrderStatus.IN_PROCESS,
  OrderStatus.SHIPPED,
  OrderStatus.DELIVERED,
  OrderStatus.CUSTOMER_REVIEW,
  OrderStatus.BILLED,
  OrderStatus.COMPLETE,
  OrderStatus.CANCELED,
];

export const SHIPMENT_STATUS = [
  ShipmentStatus.PLANNING,
  ShipmentStatus.CARRIER_ASSIGNED,
  ShipmentStatus.TENDERED,
  ShipmentStatus.TENDER_REJECTED,
  ShipmentStatus.BOOKED,
  ShipmentStatus.IN_TRANSIT,
  ShipmentStatus.DELIVERED,
  ShipmentStatus.COMPLETE,
  ShipmentStatus.CANCELED,
];

export const SHIPMENT_FINANCIAL_STATUS = [
  ShipmentFinancialStatus.NEW,
  ShipmentFinancialStatus.INVOICE_RECEIVED,
  ShipmentFinancialStatus.INVOICE_DISCREPANCY,
  ShipmentFinancialStatus.HOLD,
  ShipmentFinancialStatus.READY_FOR_BILLING,
  ShipmentFinancialStatus.BILLED,
  ShipmentFinancialStatus.PAID,
  ShipmentFinancialStatus.COMPLETE,
  ShipmentFinancialStatus.CANCELLED,
];

export const isOrderStatus = isSomeEnum(OrderStatus);
export const isShipmentStatus = isSomeEnum(ShipmentStatus);
export const isShipmentFinancialStatus = isSomeEnum(ShipmentFinancialStatus);

type Status = OrderStatus | ShipmentStatus | ShipmentFinancialStatus;

export const isStatusEqualOrBefore = (
  status?: Status,
  benchmark?: Status,
): boolean => {
  if (!status || !benchmark) {
    return false;
  }

  let statusList: Status[];
  if (isOrderStatus(status)) {
    statusList = ORDER_STATUS;
  } else if (isShipmentStatus(status)) {
    statusList = SHIPMENT_STATUS;
  } else {
    statusList = SHIPMENT_FINANCIAL_STATUS;
  }
  return statusList.indexOf(status) <= statusList.indexOf(benchmark);
};

export const isStatusEqualOrAfter = (
  status?: Status,
  benchmark?: Status,
): boolean => {
  if (!status || !benchmark) {
    return false;
  }

  let statusList: Status[];
  if (isOrderStatus(status)) {
    statusList = ORDER_STATUS;
  } else if (isShipmentStatus(status)) {
    statusList = SHIPMENT_STATUS;
  } else {
    statusList = SHIPMENT_FINANCIAL_STATUS;
  }
  return statusList.indexOf(status) >= statusList.indexOf(benchmark);
};
